import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { HomeService } from '../home-service/home.service';

@Component({
  selector: 'app-bloco-pontos-atencao',
  standalone: true,
  imports: [CommonModule, MatIconModule, RouterModule],
  templateUrl: './bloco-pontos-atencao.component.html',
  styleUrls: ['./bloco-pontos-atencao.component.scss'],
})
export class BlocoPontosAtencaoComponent implements OnInit {
  loading = true;
  obrasSemInteracao = 0;
  tarefasAtrasadas = 0;

  private readonly homeService = inject(HomeService);

  ngOnInit(): void {
    this.homeService.getNetworkStatus(7, 10).subscribe({
      next: (res) => {
        const d = res?.data;
        this.obrasSemInteracao = d?.pontosDeAtencao?.obrasSemInteracao ?? 0;
        this.tarefasAtrasadas = d?.pontosDeAtencao?.tarefasAtrasadas ?? 0;
        this.loading = false;
      },
      error: () => { this.loading = false; },
    });
  }
}